/** A continuous armed hold. Releasing or retreating restarts the whole delay. */
export function createPullHold(delayMs: number, onHold: () => void) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let fired = false;
  const cancel = () => {
    clearTimeout(timer);
    timer = undefined;
    fired = false;
  };
  return {
    cancel,
    update(armed: boolean) {
      if (!armed) { cancel(); return; }
      if (timer !== undefined || fired) return;
      timer = setTimeout(() => {
        timer = undefined;
        fired = true;
        onHold();
      }, delayMs);
    },
  };
}
